<template>
    <transition name="slide">
        <div v-if="show" :class="'notif-banner ' + type">
            <div class="message-wrapper">
                <div style="margin-right: 20px;">
                    <slot></slot>
                </div>
                {{message}}
            </div>
            <a href="javascript:" class="banner-close icon-close" v-on:click="onClose"></a>
        </div>
    </transition>
</template>

<script lang="ts">
    import { ref, onMounted, watch } from 'vue'

    export default {
        props: {
            show: {
                type: Boolean,
                default: false
            },
            type: {
                type: String,
                default: 'info'
            },
            message: {
                type: String,
                default: ''
            }
        },

        setup(props: any, { emit }) {
            const onClose = (e) => {
                emit('close')
            }

            return {
                onClose
            }
        }
    }
</script>